import useClients from "@/hooks/useClients";
import { ClientCard } from "@/ui/ClientCard";
import cn from "classnames";
import { Container } from "react-bootstrap";
import Marquee from "react-fast-marquee";
import { Buttons } from "@/ui/Buttons";

export default function ({
  className = "py-5 pt-md-6 pb-md-7",
  title = "",
  description = "",
  EditableText,
  EditableHtml,
  theme = "light",
  // buttons = [{ label: "View all Blogs", url: "/blog", variant: "blue" }],
  buttons

}) {
  const clients = useClients();

  return (
    <div className={cn(className)} data-bs-theme={theme}>
      <Container fluid="md" className="mw-xl text-center mb-5">
        <EditableText path="title" tag="h2">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        <EditableHtml path="description">
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </EditableHtml>
      </Container>
      <Marquee autoFill={true} pauseOnHover={false}>
        {clients.map((client, idx) => (
          <ClientCard key={idx} className="mx-4" {...client} />
        ))}
      </Marquee>
      <Container fluid="md" className="mw-xl text-center mb-5">
        <Buttons className="mt-md-5 justify-content-md-center" buttons={buttons} />
      </Container>
    </div>
  );
}
